import { api } from "@config/axios/axios.config";
import { QUERY_KEYS, SERVER_ROUTES } from "@constants/api.routes";
import { useQuery } from "@tanstack/react-query";
import {
	buildAttachmentPreviewUrl,
	isExternalAttachmentUrl,
	normalizeAttachmentKey,
} from "@utils/attachmentUtils";

export const useGetFileUrl = (objectKey?: string | null, options?: { enabled?: boolean }) => {
	const normalizedKey = normalizeAttachmentKey(objectKey);
	const isExternalUrl = isExternalAttachmentUrl(normalizedKey);

	return useQuery({
		queryKey: [QUERY_KEYS.INSTITUTES.ATTACHMENT_PREVIEW, normalizedKey],
		queryFn: async () => {
			if (!normalizedKey) return null;
			if (isExternalUrl) return normalizedKey;

			const response = await api.get(
				buildAttachmentPreviewUrl(SERVER_ROUTES.INSTITUTES.ATTACHMENT_PREVIEW, normalizedKey),
			);

			return response?.data;
		},
		enabled: options?.enabled !== undefined ? options.enabled : !!normalizedKey && !isExternalUrl,
	});
};
